import React from 'react';
import moment from 'moment';
import classes from './UserProfileCard.module.scss';
import 'moment/locale/ru';
import { User } from '../../types/user';

type Props = {
  userInfo: User | null;
};

export const UserProfileCard = ({ userInfo }: Props) => {
  return (
    <div className={classes.userInfo__wrap}>
      <div className={classes.userInfo__content}>
        <div className={classes.title}>
          <div className={classes.title__name}>
            {userInfo?.surname} {userInfo?.name}
          </div>
          <div className={classes.title__role}>{userInfo?.roleName}</div>
        </div>
        <div className={classes.data}>
          <div className={classes.data__item}>
            <div className={classes.title}>Дата создания</div>
            <div className={classes.content}>
              {moment(userInfo?.createdAt).format('LL')}
            </div>
          </div>
          <div className={classes.data__item}>
            <div className={classes.title}>Id</div>
            <div className={classes.content}>{userInfo?.id}</div>
          </div>
          <div className={classes.data__item}>
            <div className={classes.title}>Статус</div>
            <div className={classes.content}>{userInfo?.statusName}</div>
          </div>
          <div className={classes.data__item}>
            <div className={classes.title}>E-mail</div>
            <div className={classes.content}>{userInfo?.email}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
